tinymce.Resource.add('tinymce.html-i18n.help-keynav.hr',
'<h1>Početak navigacije na tipkovnici</h1>\n' +
  '\n' +
  '<dl>\n' +
  '  <dt>Fokusiranje trake izbornika</dt>\n' +
  '  <dd>Windows ili Linux: Alt+F9</dd>\n' +
  '  <dd>macOS: &#x2325;F9</dd>\n' +
  '  <dt>Fokusiranje alatne trake</dt>\n' +
  '  <dd>Windows ili Linux: Alt+F10</dd>\n' +
  '  <dd>macOS: &#x2325;F10</dd>\n' +
  '  <dt>Fokusiranje podnožja</dt>\n' +
  '  <dd>Windows ili Linux: Alt+F11</dd>\n' +
  '  <dd>macOS: &#x2325;F11</dd>\n' +
  '  <dt>Fokusiranje obavijesti</dt>\n' +
  '  <dd>Windows ili Linux: Alt + F12</dd>\n' +
  '  <dd>macOS: &#x2325;F12</dd>\n' +
  '  <dt>Fokusiranje kontekstne alatne trake</dt>\n' +
  '  <dd>Windows, Linux ili macOS: Ctrl+F9</dd>\n' +
  '</dl>\n' +
  '\n' +
  '<p>Navigacija će započeti kod prve stavke na korisničkom sučelju, koja će biti istaknuta ili podcrtana ako se radi o prvoj stavci u\n' +
  '  putu elementa u podnožju.</p>\n' +
  '\n' +
  '<h1>Navigacija između dijelova korisničkog sučelja</h1>\n' +
  '\n' +
  '<p>Za pomicanje s jednog dijela korisničkog sučelja na drugi pritisnite <strong>tabulator</strong>.</p>\n' +
  '\n' +
  '<p>Za pomicanje s jednog dijela korisničkog sučelja na prethodni pritisnite <strong>Shift + tabulator</strong>.</p>\n' +
  '\n' +
  '<p>Ovo je redoslijed pomicanja <strong>tabulatora</strong> po dijelovima korisničkog sučelja:</p>\n' +
  '\n' +
  '<ol>\n' +
  '  <li>Traka izbornika</li>\n' +
  '  <li>Pojedinačne grupe na alatnoj traci</li>\n' +
  '  <li>Bočna traka</li>\n' +
  '  <li>Put elemenata u podnožju</li>\n' +
  '  <li>Gumb za pomicanje po broju riječi u podnožju</li>\n' +
  '  <li>Veza na brand u podnožju</li>\n' +
  '  <li>Značajka za promjenu veličine alata za uređivanje u podnožju</li>\n' +
  '</ol>\n' +
  '\n' +
  '<p>Ako neki dio korisničkog sučelja nije naveden, on se preskače.</p>\n' +
  '\n' +
  '<p>Ako u podnožju postoji fokus za navigaciju na tipkovnici, a nema vidljive bočne trake, pritiskom na <strong>Shift + tabulator</strong>\n' +
  '  fokus se prebacuje na prvu skupinu na alatnoj traci, ne na zadnju.</p>\n' +
  '\n' +
  '<h1>Navigacija unutar dijelova korisničkog sučelja</h1>\n' +
  '\n' +
  '<p>Za pomicanje s jednog elementa korisničkog sučelja na drugi pritisnite tipku s odgovarajućom <strong>strelicom</strong>.</p>\n' +
  '\n' +
  '<p>Tipke s <strong>lijevom</strong> i <strong>desnom</strong> strelicom</p>\n' +
  '\n' +
  '<ul>\n' +
  '  <li>služe za pomicanje između izbornika na alatnoj traci.</li>\n' +
  '  <li>otvaraju podizbornik unutar izbornika.</li>\n' +
  '  <li>služe za pomicanje između gumba unutar skupina na alatnoj traci.</li>\n' +
  '  <li>služe za pomicanje između stavki na elementu puta u podnožju.</li>\n' +
  '</ul>\n' +
  '\n' +
  '<p>Tipke s <strong>donjom</strong> i <strong>gornjom</strong> strelicom</p>\n' +
  '\n' +
  '<ul>\n' +
  '  <li>služe za pomicanje između stavki unutar izbornika.</li>\n' +
  '  <li>služe za pomicanje između stavki na alatnoj traci skočnog izbornika.</li>\n' +
  '</ul>\n' +
  '\n' +
  '<p>Tipkama <strong>strelica</strong> kružno se pomičete unutar dijela korisničkog sučelja koji je u fokusu.</p>\n' +
  '\n' +
  '<p>Za zatvaranje otvorenog izbornika, otvorenog podizbornika ili otvorenog skočnog izbornika pritisnite tipku <strong>Esc</strong>.</p>\n' +
  '\n' +
  '<p>Ako je fokus trenutačno postavljen na vrh pojedinačnog dijela korisničkog sučelja, pritiskom na tipku <strong>Esc</strong> također\n' +
  '  u potpunosti zatvarate navigaciju na tipkovnici.</p>\n' +
  '\n' +
  '<h1>Izvršavanje radnji putem stavki izbornika ili gumba na alatnoj traci</h1>\n' +
  '\n' +
  '<p>Nakon što se istakne stavka izbornika ili gumb na alatnoj traci s radnjom koju želite izvršiti, pritisnite tipku <strong>Return</strong>, <strong>Enter</strong>\n' +
  '  ili <strong>razmak</strong> da biste pokrenuli željenu radnju.</p>\n' +
  '\n' +
  '<h1>Navigacija dijaloškim okvirima izvan kartica</h1>\n' +
  '\n' +
  '<p>Prilikom otvaranja dijaloških okvira izvan kartica fokus se nalazi na prvoj interaktivnoj komponenti.</p>\n' +
  '\n' +
  '<p>Navigaciju između interaktivnih dijaloških komponenata vršite pritiskom na <strong>tabulator</strong> ili <strong>Shift + tabulator</strong>.</p>\n' +
  '\n' +
  '<h1>Navigacija dijaloškim okvirima u karticama</h1>\n' +
  '\n' +
  '<p>Prilikom otvaranja dijaloških okvira u karticama fokus se nalazi na prvom gumbu u izborniku unutar kartice.</p>\n' +
  '\n' +
  '<p>Navigaciju između interaktivnih komponenata dijaloškog okvira u kartici vršite pritiskom na <strong>tabulator</strong> ili\n' +
  '  <strong>Shift + tabulator</strong>.</p>\n' +
  '\n' +
  '<p>Na karticu s drugim dijaloškim okvirom možete se prebaciti tako da stavite fokus na izbornik kartice pa pritisnete tipku s odgovarajućom <strong>strelicom</strong>\n' +
  '  za kružno pomicanje između dostupnih kartica.</p>\n');